import { createContext, useContext, useMemo } from 'react';
import useSummaryMetrics from './hooks/useSummaryMetrics';

export const PlanContext = createContext();
export const usePlanContext = () => useContext(PlanContext);

const PlanProvider = ({ children }) => {
  const {
    comparisonMetrics,
    comparisonTotalMetrics,
    impactMetrics,
    metricList,
    tagMetricList,
    scenarioMetrics,
    scenarioTotalMetrics,
    selectedSummaryItem,
    selectSummaryItem,
  } = useSummaryMetrics();

  const context = useMemo(() => {
    return {
      comparisonMetrics,
      comparisonTotalMetrics,
      impactMetrics,
      metricList,
      scenarioMetrics,
      scenarioTotalMetrics,
      selectedSummaryItem,
      selectSummaryItem,
      tagMetricList,
    };
  }, [
    comparisonMetrics,
    comparisonTotalMetrics,
    impactMetrics,
    scenarioTotalMetrics,
    selectedSummaryItem,
    metricList,
    tagMetricList,
  ]);

  return (
    <PlanContext.Provider value={context}>{children}</PlanContext.Provider>
  );
};

export default PlanProvider;
